import { img } from '../assets/assets'
import { IUser } from '../types/user'
import { Username } from './profile/Profile'
import { Link } from 'react-router-dom'
import {
    getCALPrice,
    getUserAvatar,
    getUserBackground,
    getUserLink,
    getUserName,
    reduction,
} from '../utils/methods'
// import { Button } from './UI/Buttons'
import { FC, useCallback, useState } from 'react'
import { fromWeiToString } from '../utils/wallet/utils'
import { useEffect } from 'react'
import { useTypedSelector } from '../hooks/useTypedSelector'
import { FollowButton } from './profile/Following'

export const UserList: FC<{
    users: IUser[]
    title?: string
}> = ({ users }) => {
    return (
        <div className="seller">
            
            {users.map((u) => (
                <UserItem user={u} key={u.id}></UserItem>
            ))}
        </div>
    )
}

export const UserItem: FC<{
    user: IUser
}> = ({ user }) => {
    const [usd, setUsd] = useState('0')
    const { auth } = useTypedSelector((s) => s)

    const initUsd = useCallback(async () => {
        const getUsd = await getCALPrice
        setUsd(getUsd(fromWeiToString(user.totalSalesProfit)))
    }, [user])

    useEffect(() => {
        initUsd()
    }, [user.totalSalesProfit, initUsd])

    return (
        <div className="seller__item">
            <div className="seller__art">
                <img src={getUserBackground(user.background)} alt="" />
            </div>
            <div className="seller__body">
                <Link to={getUserLink(user)} className="seller__image">
                    <img src={getUserAvatar(user.avatar)} alt="avatar" />
                </Link>
                <Link to={getUserLink(user)} className="seller__name">
                    {getUserName(user)}
                </Link>
                <Username user={user} className="seller__nickname"></Username>
                <pre className="seller__description">{user.description}</pre>

                <div className="seller-follow">
                    <div className="seller-follow__space">
                        <div className="seller-follow__quantity">
                            {user.followingsCount || 0}
                        </div>
                        <div className="seller-follow__info">Following</div>
                    </div>
                    <div className="seller-follow__space">
                        <div className="seller-follow__quantity">
                            {user.followersCount || 0}
                        </div>
                        <div className="seller-follow__info">Followers</div>
                    </div>

                    {!!auth.id.length && auth.id !== user.id && (
                        <div className="seller-follow__button">
                            <FollowButton
                                user={user}
                                size="small"
                            ></FollowButton>
                        </div>
                    )}
                </div>
                <div className="seller-sales">
                    <div className="seller-sales__logo">
                        <img src={img.logo} alt="logo" />
                    </div>
                    <div className="seller-sales__info">
                        {`${user.totalSalesCount} sales on ${reduction(
                            fromWeiToString(user.totalSalesProfit)
                        )} `}
                        <span>({usd}$)</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export const UserMini: FC<{
    user: IUser
    className?: string
    size?: 'middle' | 'small'
}> = ({ user, className, size }) => {
    return (
        <Link to={getUserLink(user)} className={`user-mini ${className || ''}`}>
            <div
                className={`user-mini__avatar ${
                    size ? `user-mini__avatar-${size}` : ''
                }`}
            >
                <img src={getUserAvatar(user.avatar)} alt="" />
            </div>
            <div className="user-mini__info">
                <div
                    className={`user-mini__name ${
                        size ? `user-mini__name-${size}` : ''
                    }`}
                >
                    {getUserName(user)}
                </div>
                {user.metaName ? (
                    <div
                        className={`user-mini__metaname ${
                            size ? `user-mini__metaname-${size}` : ''
                        }`}
                    >
                        @{user.metaName}
                    </div>
                ) : null}
            </div>
        </Link>
    )
}
